import React from 'react';
import { faSnowflake } from '@fortawesome/pro-regular-svg-icons/faSnowflake';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function SnowflakeRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faSnowflake} {...props} />;
}
